<template>
    <div class="form-group" :class="model.size">
        <div>
            <label class="font-weight-bold" :for="'input' + _uid">{{ model.label }}</label>
            <i class="far fa-edit float-right text-primary pointer" @click="showEditPrompt"></i>
        </div>
        <input :type="model.type"
               :id="'input' + _uid"
               :name="'input' + _uid"
               @input="inputChanged"
               v-model="value"
               :data-vv-as="model.label"
               class="form-control"
               aria-describedby="descriptionHelp" />
        <span class="text-danger" v-if="errors.has('input' + _uid)">{{ errors.first('input' + _uid) }}</span>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>

        <vs-prompt class="vs-lg"
                   :title="$t('editor.common.editComponentProperties')"
                   :accept-text="$t('buttons.ok')"
                   :cancel-text="$t('buttons.cancel')"
                   :active.sync="activePrompt"
                   :is-valid="validationSuccess"
                   @cancel="cancelPrompt"
                   @close="cancelPrompt"
                   color="primary">
            <div>
                <div v-if="model.locked">
                    <h4 class="text-danger"><i class="fas fa-lock"></i> {{ $t('registers.dynamic.gridHeaders.locked') }}</h4>
                </div>

                <FieldTemplateSelector v-model="model"
                                       :isFormField="isFormField"
                                       :isAuxRegisterField="isAuxRegisterField"
                                       :isEventFieldCode="isEventFieldCode">
                </FieldTemplateSelector>

                <vs-input :label="$t('editor.common.name')" v-model="model.name" />
                <span class="text-danger" v-if="!validName">{{ $t('validation.requiredField') }}</span>

                <div class="row mt-2 mb-2 pl-3">
                    <vs-checkbox v-model="model.isTemplate">{{ $t('editor.common.saveAsTemplate') }}</vs-checkbox>
                </div>

                <vs-input :label="$t('editor.common.nameEN')" v-model="model.nameEn"></vs-input>

                <vs-input :label="$t('editor.common.label')" v-model="model.label" />
                <span class="text-danger" v-if="!validLabel">{{ $t('validation.requiredField') }}</span>
                <vs-input :label="$t('editor.common.labelEn')" v-model="model.labelEn"></vs-input>
                <span class="text-danger" v-if="!validLabelEN">{{ $t('validation.requiredField') }}</span>

                <vs-input :label="$t('editor.common.description')" v-model="model.description" />
                <vs-input :label="$t('editor.common.descriptionEn')" v-model="model.descriptionEn" />

                <size-dropdown v-model="model.size"></size-dropdown>
                <vs-select v-model="model.inputType"
                           :label="$t('editor.common.type')"
                           width="100%"
                           autocomplete
                           :placeholder="$t('choose')"
                           :change="inputTypeChanged">
                    <vs-select-item :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in inputTypes" />
                </vs-select>
                <div v-if="model.inputType === 'text' || model.inputType === 'textarea'">
                    <vs-input type="number" :label="$t('editor.common.textMinLength')" v-model="model.textMinLength"></vs-input>
                    <span class="text-danger" v-if="!validTextMinLength">{{ $t('validation.requiredField') }}</span>
                    <vs-input type="number" :label="$t('editor.common.textMaxLength')" v-model="model.textMaxLength"></vs-input>
                    <span class="text-danger" v-if="!validTextMaxLength">{{ $t('validation.requiredField') }}</span>
                    <vs-input :label="$t('editor.common.defaultValue')" v-model="model.textDefaultValue"></vs-input>
                    <span class="text-danger" v-if="!validFefaultTextValue">{{ $t('validation.defaultTextValue') }}</span>
                    <!--<hr />-->
                    <!--<vs-input :label="$t('editor.common.defaultValue')" v-model="model.regexValidation"></vs-input>
        <span class="text-danger" v-if="!validFefaultTextValue">{{ $t('validation.defaultTextValue') }}</span>-->
                    <!--<vs-input :label="$t('editor.common.defaultValue')" v-model="model.validationError"></vs-input>
        <span class="text-danger" v-if="!validFefaultTextValue">{{ $t('validation.defaultTextValue') }}</span>
        <vs-input :label="$t('editor.common.defaultValue')" v-model="model.validationErrorEn"></vs-input>
        <span class="text-danger" v-if="!validFefaultTextValue">{{ $t('validation.defaultTextValue') }}</span>-->
                </div>
                <div v-else-if="model.inputType === 'number'">
                    <vs-select v-model="model.numberType"
                               :label="$t('editor.common.numberType')"
                               width="100%"
                               autocomplete
                               :placeholder="$t('choose')"
                               :change="numberTypeChanged">
                        <vs-select-item :key="index"
                                        :value="item.value"
                                        :text="item.text"
                                        v-for="(item,index) in numberTypes" />
                    </vs-select>
                    <div v-if="model.numberType === 'int'">
                        <vs-input type="number" :label="$t('editor.common.numberMinLength')" v-model="model.intMinValue"></vs-input>
                        <span class="text-danger" v-if="!validIntMinValue">{{ $t('validation.invalidIntNumber') }}</span>
                        <vs-input type="number" :label="$t('editor.common.numberMaxLength')" v-model="model.intMaxValue"></vs-input>
                        <span class="text-danger" v-if="!validIntMaxValue">{{ $t('validation.invalidIntNumber') }}</span>
                        <vs-input type="number" :label="$t('editor.common.defaultValue')" v-model="model.intDefaultValue"></vs-input>
                        <span class="text-danger" v-if="!validIntDefaultValue">{{ $t('validation.invalidIntNumber') }}</span>
                    </div>
                    <div v-else-if="model.numberType === 'decimal'">
                        <vs-input type="number" :label="$t('editor.common.numberMinLength')" v-model="model.decimalMinValue"></vs-input>
                        <span class="text-danger" v-if="!validDecimalMinValue">{{ $t('validation.invalidDecimalNumber') }}</span>
                        <vs-input type="number" :label="$t('editor.common.numberMaxLength')" v-model="model.decimalMaxValue"></vs-input>
                        <span class="text-danger" v-if="!validDecimalMaxValue">{{ $t('validation.invalidDecimalNumber') }}</span>
                        <vs-input type="number" :label="$t('editor.common.defaultValue')" v-model="model.decimalDefaultValue"></vs-input>
                        <span class="text-danger" v-if="!validDecimalDefaultValue">{{ $t('validation.invalidDecimalNumber') }}</span>
                        <vs-input :label="$t('editor.common.numberFormat')" v-model="model.numberFormat"></vs-input>
                        <vs-input type="number" min="0" max="18" :label="$t('editor.common.decimalPrecision')" v-model="model.decimalPrecision"></vs-input>
                        <span class="text-danger" v-if="!validDecimalPrecision">{{ $t('validation.invalidDecimalPrecision') }}</span>
                    </div>
                </div>
                <hr>
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.isRequired">{{ $t('validation.requiredField') }}</vs-checkbox>
                </div>
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.isUnique">{{ $t('validation.uniqueField') }}</vs-checkbox>
                </div>
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.isReadOnly">{{ $t('validation.readOnlyField') }}</vs-checkbox>
                </div>
                <div class="float-left mt-2" v-if="model.inputType === 'text'">
                    <vs-checkbox v-model="model.textAllowNullOrEmpty">{{ $t('editor.common.textAllowNullOrEmpty') }}</vs-checkbox>
                </div>

                <div class="clearfix"></div>
                <hr />
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.showInDescription">{{ $t('editor.common.showInDescription') }}</vs-checkbox>
                </div>

                <div class="clearfix"></div>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
    import { EditorComponentModel } from '../../models/models';
    import SizeDropdown from '../../components/editor/SizeDropdown';
    import FieldTemplateSelector from '../../components/editor/FieldTemplateSelector'
    import { Culture } from '../../models/enums';

    export default {
        inject: ['$validator'],
        props: {
            value: String,
            model: {
                type: EditorComponentModel
            },
            isFormField: {
                type: Boolean,
                default: false
            },
            isAuxRegisterField: {
                type: Boolean,
                required: false
            },
            isEventFieldCode: {
                type: Boolean,
                required: false
            },
        },
        components: {
            SizeDropdown,
            FieldTemplateSelector
        },
        watch: {
            model: {
                handler: function (model) {
                    if (model.inputType === 'number') {
                        this.model.textAllowNullOrEmpty = this.originalModel.textAllowNullOrEmpty;
                    }
                },
                deep: true
            }
        },
        data() {
            return {
                activePrompt: false,
                validations: '',
                originalModel: new EditorComponentModel(),
                inputTypes: [{
                    text: this.$t('editor.input.typeText'),
                    value: 'text'
                }, {
                    text: this.$t('editor.input.typeNumber'),
                    value: 'number'
                }, {
                    text: this.$t('editor.input.typeTextarea'),
                    value: 'textarea'
                }],
                numberTypes: [{
                    text: this.$t('editor.input.intType'),
                    value: 'int'
                }, {
                    text: this.$t('editor.input.decimalType'),
                    value: 'decimal'
                }],
            }
        },
        methods: {
            inputChanged(event) {
                this.$emit('input', event.target.value);
            },
            showEditPrompt(event) {
                this.originalModel = new EditorComponentModel(this.model);
                this.activePrompt = true;
            },
            cancelPrompt() {
                this.changeModelToOriginalModel();
            },
            changeModelToOriginalModel() {
                this.model.name = this.originalModel.name;
                this.model.nameEn = this.originalModel.nameEn;
                this.model.label = this.originalModel.label;
                this.model.labelEn = this.originalModel.labelEn;
                this.model.size = this.originalModel.size;
                this.model.textMinLength = this.originalModel.textMinLength;
                this.model.textMaxLength = this.originalModel.textMaxLength;
                this.model.textDefaultValue = this.originalModel.textDefaultValue;
                this.model.isRequired = this.originalModel.isRequired;
                this.model.isUnique = this.originalModel.isUnique;
                this.model.isReadOnly = this.originalModel.isReadOnly;
                this.model.textAllowNullOrEmpty = this.originalModel.textAllowNullOrEmpty;
                this.model.inputType = this.originalModel.inputType;
                this.model.numberType = this.originalModel.numberType;
                this.model.intMinValue = this.originalModel.intMinValue;
                this.model.intMaxValue = this.originalModel.intMaxValue;
                this.model.intDefaultValue = this.originalModel.intDefaultValue;
                this.model.decimalMinValue = this.originalModel.decimalMinValue;
                this.model.decimalMaxValue = this.originalModel.decimalMaxValue;
                this.model.decimalDefaultValue = this.originalModel.decimalDefaultValue;
                this.model.decimalPrecision = this.originalModel.decimalPrecision;
                this.model.numberFormat = this.originalModel.numberFormat;
                this.model.showInDescription = this.originalModel.showInDescription;
            },
            inputTypeChanged() {
                this.resetTextEditorConstraintsValues();
            },
            numberTypeChanged() {
                this.resetTextEditorConstraintsValues();
            },
            resetTextEditorConstraintsValues() {
                this.model.textMinLength = this.originalModel.textMinLength;
                this.model.textMaxLength = this.originalModel.textMaxLength;
                this.model.textDefaultValue = this.originalModel.textDefaultValue;
                this.model.intMinValue = this.originalModel.intMinValue;
                this.model.intMaxValue = this.originalModel.intMaxValue;
                this.model.intDefaultValue = this.originalModel.intDefaultValue;
                this.model.decimalMinValue = this.originalModel.decimalMinValue;
                this.model.decimalMaxValue = this.originalModel.decimalMaxValue;
                this.model.decimalDefaultValue = this.originalModel.decimalDefaultValue;
                this.model.decimalPrecision = this.originalModel.decimalPrecision;
                this.model.numberFormat = this.originalModel.numberFormat;
            }
        },
        computed: {
            validName() {
                return this.model.name.length > 0;
            },
            validLabel() {
                return this.model.label.length > 0;
            },
            validLabelEN() {
                return this.model.labelEn.length > 0;
            },
            validTextMinLength() {
                return !isNaN(parseInt(this.model.textMinLength));
            },
            validTextMaxLength() {
                return !isNaN(parseInt(this.model.textMaxLength));
            },
            validIntMinValue() {
                return !isNaN(parseInt(this.model.intMinValue));
            },
            validIntMaxValue() {
                return !isNaN(parseInt(this.model.intMaxValue));
            },
            validIntDefaultValue() {
                return !isNaN(parseInt(this.model.intDefaultValue));
            },
            validDecimalMinValue() {
                return !isNaN(parseInt(this.model.intMinValue));
            },
            validDecimalMaxValue() {
                return !isNaN(parseInt(this.model.intMaxValue));
            },
            validDecimalDefaultValue() {
                return !isNaN(parseInt(this.model.intDefaultValue));
            },
            validDecimalPrecision() {
                let val = parseInt(this.model.decimalPrecision);
                return !isNaN(val) && val >= 0 && val <= 18;
            },
            validFefaultTextValue() {
                if (this.model.inputType !== 'text' || this.model.textAllowNullOrEmpty) {
                    return true;
                }
                return this.model.textDefaultValue !== '';
            },
            validationSuccess() {
                // this.mode.locked - Locked for edition
                return !this.model.locked && this.validName && this.validLabel && this.validLabelEN && this.validTextMinLength
                    && this.validTextMaxLength && this.validFefaultTextValue
                    && this.validIntMinValue && this.validIntMaxValue && this.validIntDefaultValue
                    && this.validDecimalMinValue && this.validDecimalMaxValue && this.validDecimalDefaultValue
                    && this.validDecimalPrecision;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
        }
    }
</script>

<style scoped>
    .vs-input {
        width: 100%;
    }

    ::v-deep {
        .vs-dialog {
            min-width: 800px !important;
            height: auto;
        }
    }
</style>
